import { Component, OnInit } from '@angular/core';
import { Project } from 'src/app/models/Project';
import { ModalController, AlertController } from '@ionic/angular';
import { Outcome } from 'src/app/models/outcomes/Outcome';
import { HelpModalPage } from '../help-modal/help-modal.page';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ApiExportService } from 'src/app/api-services/export.api.service';
import { AddOutcomeToProjectModalPage } from '../add-outcome-to-project-modal/add-outcome-to-project-modal.page';
import { OutcomesService } from 'src/app/services/outcomes.service';
import { ProjectOutcomeRelationService } from 'src/app/services/project-outcome-relation.service';
import { ViewOutcomeModalPage } from '../view-outcome-modal/view-outcome-modal.page';
import { ViewOutcomeSubOutcomesModalPage } from '../view-outcome-sub-outcomes-modal/view-outcome-sub-outcomes-modal.page';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-project-outcome-management',
  templateUrl: './project-outcome-management.page.html',
  styleUrls: ['./project-outcome-management.page.scss'],
})
export class ProjectOutcomeManagementPage implements OnInit {

  public project: Project;
  public projectOutcomes: Outcome[] = [];
  public paginateConfig: any;
  public key: string = 'title'; // Default field
  public reverse: boolean = false;  // Default Sort (false = Ascending)
  public caretDownIcon = 'arrow-dropdown';
  public caretUpIcon = 'arrow-dropup';
  public isModalOpened: boolean = false;

  constructor(
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public exportAPIService: ApiExportService,
    public outcomeService: OutcomesService,
    public ProjectOutcomeRelationService: ProjectOutcomeRelationService,
    public alertController: AlertController,
    public deepCopyService: DeepCopyService,
    public messageService: MessagesService

  ) {
    this.paginateConfig = {
      id: 'first',
      itemsPerPage: 3,
      currentPage: 1
    };
  }

  ngOnInit() {
  }

  async updateProjectOutcomes() {
    var projectOutcomesRelationList = await this.ProjectOutcomeRelationService.getProjectOutcomeRelationByProjectId(this.project.projectId);
    return await new Promise<void>((resolve) => {
      if (projectOutcomesRelationList.length != 0) {
        let projectOutcomeRelationsOutcomeIds = projectOutcomesRelationList.map(x => { return x.outcomeId });
        this.projectOutcomes = this.outcomeService.outcomeGroups.filter(y => projectOutcomeRelationsOutcomeIds.includes(y.outcomeId));
        resolve();
      }
      else {
        this.projectOutcomes = [];
        resolve();
      }
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  sortBy(key: string) {
    if (this.key != key) {
      this.key = key;
      this.reverse = false;
    } else {
      this.reverse = !this.reverse;
    }
  }

  async viewSubOutcomes(event, outcome) {
    this.unfocusService.unfocus(event);
    let subOutcomes = [] as Outcome[];

    await this.outcomeService.getSubOutcomes(outcome.outcomeId);
    if (this.outcomeService.subOutcomes.length != 0) {
      subOutcomes = this.deepCopyService.deepCopy(this.outcomeService.subOutcomes);
    }

    const modal = await this.modalController.create({
      component: ViewOutcomeSubOutcomesModalPage,
      id: 'sub-outcome-view-modal',
      componentProps: {
        "outcome": outcome,
        "subOutcomes": subOutcomes,
      }
    });

    return await modal.present();
  }

  async viewOutcomeInformation(event, outcome) {
    this.unfocusService.unfocus(event);
    const modal = await this.modalController.create({
      component: ViewOutcomeModalPage,
      id: 'outcome-view-modal',
      componentProps: {
        "Outcome": outcome
      }
    });

    return await modal.present();
  }

  async removeOutcome(event, outcome) {
    this.unfocusService.unfocus(event);
    const alert = await this.alertController.create({
      header: 'Remove Outcome From Project',
      message: "Do you want to remove Outcome '" + outcome.title + "' from this Project?",
      cssClass: 'leave-alert quizard-alert quizard-leave-alert',
      buttons: [{
        text: 'No',
        cssClass: 'leave-button',
        handler: () => {
        }
      }, {
        text: 'Yes',
        cssClass: 'leave-button',
        handler: () => {
          this.messageService.presentLoadingWindow("Removing Outcome From Project...");
          this.ProjectOutcomeRelationService.removeProjectOutcomeRelationByOutcomeAndProjectId(outcome.outcomeId, this.project.projectId).subscribe(x => {
            this.messageService.loadingWindow.dismiss();
            this.updateProjectOutcomes().then(x => {
              this.messageService.presentToast('Outcome removed successfully!', 'success', 'Project Outcomes');
            });
          });
        }
      }]
    });
    await alert.present();
  }

  async addOutcomes(event) {
    this.unfocusService.unfocus(event);
    var projectOutcomesRelationList = await this.ProjectOutcomeRelationService.getProjectOutcomeRelationByProjectId(this.project.projectId);
    let avaliableOutcomes = [] as Outcome[];
    if (projectOutcomesRelationList.length != 0) {
      let projectOutcomeRelationsOutcomeIds = projectOutcomesRelationList.map(x => { return x.outcomeId });
      avaliableOutcomes = this.outcomeService.outcomeGroups.filter(y => !projectOutcomeRelationsOutcomeIds.includes(y.outcomeId));
    }
    else {
      avaliableOutcomes = this.outcomeService.outcomeGroups;
    }
    avaliableOutcomes.forEach(outcome => {
      outcome.checked = false;
    });

    if (!this.isModalOpened) {
      this.isModalOpened = true;
      const addModal = await this.modalController.create({
        component: AddOutcomeToProjectModalPage,
        id: 'add-sub-outcome-modal',
        componentProps: {
          "Outcomes": avaliableOutcomes,
          "OutcomeCount": avaliableOutcomes.length,
          "projectId": this.project.projectId
        },
      });

      addModal.onDidDismiss().then(result => {
        this.updateProjectOutcomes().then(x => {
          if (result.data) {
            this.messageService.presentToast("Outcome added successfully!", "success", "Project Outcomes");
          }
          this.isModalOpened = false;
        });
      });
      await addModal.present();
    }
  }

  async exportRationale(event) {
    this.unfocusService.unfocus(event);
    if (this.projectOutcomes.length != 0) {
      this.exportAPIService.exportRationale(this.project.projectId).then(x => {
      });
    }
    else {
      const alert = await this.alertController.create({
        header: 'No Outcomes Added To Project',
        message: "Please add Outomes to the Project before downloading the Outcome Rationale.",
        cssClass: 'leave-alert',
        buttons: [{
          text: 'OK',
          cssClass: 'leave-button',
          handler: () => {
          }
        }]
      });
      await alert.present();
    }

  }

  async viewHelp(event) {
    this.unfocusService.unfocus(event);
    const modal = await this.modalController.create({
      component: HelpModalPage,
      id: 'help-modal-OutcomesOnProject',
      componentProps: {
        "helpToDisplay": "OutcomesOnProject"
      }
    });

    return await modal.present();
  }
}
